import React from 'react';
import { Button, Flex, BoxProps } from '@chakra-ui/react';
import { Member } from 'types/splits.types';

export interface ProposeSplitActionsProps extends BoxProps {
  className?: string;
  onClose: () => void;
  confirmEnabled: boolean;
  onMemberSelect: (member: Member) => void;
}

export const ProposeSplitActions: React.FC<ProposeSplitActionsProps> = ({
  onClose,
  confirmEnabled,
  onMemberSelect,
  ...boxProps
}) => (
  <Flex
    position="absolute"
    bottom={4}
    right={4}
    gap={4}
    justifyContent="flex-end"
    {...boxProps}
  >
    <Button variant="secondary" onClick={onClose}>
      Cancel
    </Button>
    <Button type="submit" isDisabled={!confirmEnabled}>
      Propose
    </Button>
  </Flex>
);
